const server = process.env.REACT_APP_SERVER;

async function getSucursales(regional) {
    var consulta = await fetch(`${server}/sqlComun/getSucursales`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            regional
        })
    });
    return consulta.json();
}

async function getInventarioSucursal(info) {
    var consulta = await fetch(`${server}/supervision/getInventarioSucursal`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            'regional': info.regional, 'SUCURSAL': info.SUCURSAL, 'FECHA': info.fecha, 'TIPO': info.tipo, 'ID_EMPLEADO': info.ID_EMPLEADO
        })
    });
    return consulta.json();
}

async function setEstadoInventarioSucursal(info) {
    var consulta = await fetch(`${server}/supervision/setEstadoInventarioSucursal`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            'regional': info.regional, 'SUCURSAL': info.SUCURSAL,
            'ESTADO': info.ESTADO, 'ID_EMPLEADO': info.ID_EMPLEADO,
            'ID_INVENTARIO': info.ID_INVENTARIO
        })
    });
    return consulta.json();
}
async function guardarInventarioIniSucursal(info) {
    var consulta = await fetch(`${server}/supervision/guardarInventarioIniSucursal`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            'regional': info.regional, 'SUCURSAL': info.SUCURSAL,
            'ID_EMPLEADO': info.ID_EMPLEADO,
            'ID_INVENTARIO': info.ID_INVENTARIO,
            'DATOS': info.DATOS,
            'OBSERVACIONES': info.OBSERVACIONES
        })
    });
    return consulta.json();
}

async function getInformacionPedidos(info) {
    var consulta = await fetch(`${server}/reporte/getInformacionPedidos`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...info,
        })
    });
    return consulta.json();
}

async function getColaboradoresPrueba(info) {
    var consulta = await fetch(`${server}/sqlComun/empleado/testEmpleado`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...info,
        })
    });
    return consulta.json();
}
async function getInfoCategoriasSys(info) {
    var consulta = await fetch(`${server}/sqlComun/getInfoCategoriasSys`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...info,
        })
    });
    return consulta.json();
}
async function getCatalogoColaborador(info) {
    var consulta = await fetch(`${server}/sqlComun/getCatalogoColaborador`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...info,
        })
    });
    return consulta.json();
}
async function getInfoColaborador(info) {
    var consulta = await fetch(`${server}/sqlComun/getInfoColaborador`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...info,
        })
    });
    return consulta.json();
}
async function getColaboradoreTelegram(info) {
    var consulta = await fetch(`${server}/sqlComun/empleado/telegramchat`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...info,
        })
    });
    return consulta.json();
}
async function sendMsgTelegram(info) {
    var consulta = await fetch(`${server}/sqlComun/sendMsgTelegram`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...info,
        })
    });
    return consulta.json();
}
async function validarColaboradorEncuesta(info) {
    var consulta = await fetch(`${server}/sqlComun/validarColaboradorEncuesta`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...info,
        })
    });
    return consulta.json();
}
async function cifrarEncuestaurl(info) {
    var consulta = await fetch(`${server}/sqlComun/cifrarEncuestaurl`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...info,
        })
    });
    return consulta.json();
}

async function getNombreSucursalDadoID(info) {
    var consulta = await fetch(`${server}/sqlComun/getNombreSucursalDadoID`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...info,
        })
    });
    return consulta.json();
}

export default {
    getSucursales, getInventarioSucursal,
    setEstadoInventarioSucursal, guardarInventarioIniSucursal,
    getInformacionPedidos, getColaboradoresPrueba, getInfoCategoriasSys,
    getCatalogoColaborador, getInfoColaborador, getColaboradoreTelegram,
    sendMsgTelegram, validarColaboradorEncuesta,cifrarEncuestaurl, getNombreSucursalDadoID
}